import React, { useMemo } from "react";
import {
    Redirect,
    RouteComponentProps,
    Switch,
    useHistory
} from "react-router-dom";
import CourseLayout from "./components/CourseLayout";
import SignIn from "./SignIn";
import useRequest from "utils/useRequest";
import { getCourseData, toNumber } from "service/service";
import _ from "underscore";
import CourseSpin from "./components/CourseSpin";
import { LayoutRoute } from "components/LayoutRoute";
import { CourseContext } from "./Store";

interface CourseDetailProps {
    weekTimeId: string;
}

export default function TeachLogDetail({
    match
}: RouteComponentProps<CourseDetailProps>) {
    const history = useHistory();
    const weekTimeId = toNumber(match.params.weekTimeId);
    const [CourseData, { loading }, updateCourses] = useRequest(
        () => getCourseData({}),
        {},
        []
    );
    const course = useMemo(
        () => _.find(CourseData || [], { weekTimeId }),
        [weekTimeId, CourseData]
    );

    const basename = `/course/teachlog/${weekTimeId}`;
    const path = history.location.pathname
        .substr(basename.length + 1)
        .split("/")[0]; // 模块路径

    // 不考虑无课程的情况
    if (!course) return <CourseSpin />;

    return (
        <CourseContext.Provider
            value={{ course, basename, updateCourses, path }}>
            <Switch>
                <LayoutRoute
                    key={course.weekTimeId}
                    path={`${basename}/signin`}
                    exact
                    component={SignIn}
                    layout={CourseLayout}
                />
                <Redirect to={`${basename}/signin`} />
            </Switch>
        </CourseContext.Provider>
    );
}
